import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

const freeElement = document.getElementById('free');
if (freeElement) {
  const root = createRoot(freeElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

// PUBLIC_ is RSBuild's prefix for variables it substitutes into the bundle at
// build time. Anything else is left as a literal `process.env.X` expression,
// and browsers have no `process` -- so an unprefixed name does not merely read
// as undefined, it throws a ReferenceError. REACT_APP_ was CRA's prefix and
// meant nothing here.
if (process.env.PUBLIC_ENABLE_MSW === 'true') {
  const { worker } = require('./mocks/browser');
  worker.start();
}
